import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IonAccordionGroup, MenuController } from '@ionic/angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigateRoutes, QK_CONSTATANT, RequestType, StorageConstants, TransactionStatus } from 'common/constants/app.constant';
import { CoBrandingApiQueryParams } from 'common/models/pagemodels/co-branding/co-branding.model';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { QueryParams } from 'common/models/utilitymodels/list.model';
import { SideMenuItem } from 'common/models/utilitymodels/menu.model';
import { StorageService } from 'common/services/core_services/storage.service';
import { SystemService } from 'common/services/core_services/system.service';
import { UserLogsService } from 'common/services/data_services/user-logs/user-logs.service';
import SmartechBaseCordova from 'smartech-base-cordova';

@Component({
    selector: 'bh-side-panel',
    templateUrl: './side-panel.component.html',
    styleUrls: ['../tabs/tabs.component.scss'],
})
export class SidePanelComponent implements OnInit, AfterViewInit {
    @Input() sideMenuItems: SideMenuItem[];
    @ViewChild('sbAccordionGP', { static: true }) sbAccordionGP: IonAccordionGroup;
    toggleSideMenuValue: string = '';
    @ViewChild('sidebarContainer') sidebarContainer: ElementRef;
    showDownArrow: boolean = false;
    showUpArrow: boolean = false;

    constructor(protected systemService: SystemService, private menuCtrl: MenuController, private router: Router, private modalService: NgbModal, private storageService: StorageService) { }
    viewOnlyPermission: boolean = false;
    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const userData = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
                const isEmployeeLogin = JSON.parse(this.systemService.getLocalStorage(StorageConstants.isEmployeeLogin));

                this.sideMenuItems.forEach((item: SideMenuItem) => {
                    if (userData && userData.type === 'IFA_USER') {
                        if ([NavigateRoutes.distributorprofile, NavigateRoutes.brokeragereportpayout].includes(item.url) && isEmployeeLogin) {
                            item.show = false;
                        } else {
                            item.show = true;
                        }
                    } else {
                        if (userData && userData.type === 'NON_IFA_USER') {
                            if ([NavigateRoutes.distributordashboard, NavigateRoutes.brokeragereportpayout, NavigateRoutes.investor, NavigateRoutes.oppotunity, NavigateRoutes.statement, NavigateRoutes.wishes, NavigateRoutes.statement].includes(item.url)) {
                                item.show = false;
                            }
                        } else {
                            item.show = true;
                        }
                    }

                    if (event.url.startsWith(item.url)) {
                        item.selected = true;
                        if (event.url.includes('investor-list')) {
                            item.subItems[0].selected = true;
                            item.subItems[1].selected = false;
                        } else if (event.url.includes('scheme-list')) {
                            item.subItems[1].selected = true;
                            item.subItems[0].selected = false;
                        } else if (event.url.startsWith(NavigateRoutes.capitalGainStatement) || event.url.startsWith(NavigateRoutes.accountStatement)) {
                            const selectedItem = this.sideMenuItems.find((subItem: SideMenuItem) => {
                                return subItem.url === NavigateRoutes.statement;
                            });
                            if (selectedItem) {
                                if (event.url.startsWith(NavigateRoutes.accountStatement)) {
                                    selectedItem.subItems[0].selected = true;
                                } else {
                                    selectedItem.subItems[1].selected = true;
                                }
                            }
                            item.subItems[0].selected = true;
                        }
                    } else {
                        item.selected = false;
                        item.subItems.forEach((subItem: SideMenuItem) => {
                            if (userData && userData.type === 'NON_IFA_USER' && [NavigateRoutes.transactionHistory].includes(subItem.url)) {
                                subItem.show = false;
                            } else if ([NavigateRoutes.transactionHistory].includes(subItem.url)) {
                                subItem.show = true;
                            }
                            subItem.selected = false;
                        });
                    }

                    if (this.systemService.deviceInfo.platform === 'web' && item.url === NavigateRoutes.notifications) {
                        item.show = false;
                    }
                });
                if (event.url.includes('account-statement')) {
                    const model: SideMenuItem | undefined = this.sideMenuItems.find((item: SideMenuItem) => item.id === 6);
                    model!.selected = true;
                    model!.subItems[0].selected = true;
                } else if (event.url.includes('capital-gain-statement')) {
                    const model: SideMenuItem | undefined = this.sideMenuItems.find((item: SideMenuItem) => item.id === 6);
                    model!.selected = true;
                    model!.subItems[1].selected = true;
                } else if (event.url.startsWith('/distributor/transact/') || event.url.startsWith(NavigateRoutes.transactionHistory)) {
                    const model: SideMenuItem | undefined = this.sideMenuItems.find((item: SideMenuItem) => item.id === 1);
                    model!.selected = true;
                    if (event.url.startsWith('/distributor/transact/')) {
                        model!.subItems[0].selected = true;
                        model!.subItems[1].selected = false;
                    } else if (event.url.startsWith(NavigateRoutes.transactionHistory)) {
                        model!.subItems[0].selected = false;
                        model!.subItems[1].selected = true;
                    }
                }
            }
        });
    }

    updateArrows(): void {
        setTimeout(() => {
            const container = this.sidebarContainer.nativeElement;
            const maxScrollBottom = container.scrollHeight - container.clientHeight - 20;
            this.showUpArrow = container.scrollTop > 0;
            this.showDownArrow = container.scrollTop < maxScrollBottom;
        }, 200);
    }

    scrollTo(position: 'top' | 'bottom'): void {
        const container = this.sidebarContainer.nativeElement;
        const scrollOptions: ScrollToOptions = {
            top: position === 'top' ? 0 : container.scrollHeight, // Top for 'top', scrollHeight for 'bottom'
            behavior: 'smooth', // Smooth scrolling
        };
        container.scrollTo(scrollOptions);
        this.updateArrows();
    }

    ngAfterViewInit(): void {
        this.updateArrows();
        if (this.router.url.startsWith('/distributor/transact/')) {
            if (this.router.url.includes('account-statement') || this.router.url.includes('capital-gain-statement')) {
                this.toggleSideMenuValue = '6';
            }
        } else if (this.router.url.includes('investor-list') || this.router.url.includes('scheme-list')) {
            this.toggleSideMenuValue = '3';
        }
    }

    async onItemClick(item: SideMenuItem) {
        if (!this.systemService.canNavigate) {
            this.systemService.showToaster('You are Offline!', 'error');
            return;
        }
        const routeMessage = new RouteMessage();
        routeMessage.transferData = item;
        let url = item.url;
        if (item.url.startsWith(NavigateRoutes.accountStatement) || item.url.startsWith(NavigateRoutes.capitalGainStatement) || item.url.startsWith(NavigateRoutes.bankMandateListing)) {
            url = NavigateRoutes.selectInvestor;
            if (item.url.startsWith(NavigateRoutes.accountStatement)) {
                url = url + '/account-statement';
            } else if (item.url.startsWith(NavigateRoutes.capitalGainStatement)) {
                url = url + '/capital-gain-statement';
            }
            routeMessage.type = RequestType.GET;
        } else if (item.url.startsWith('/distributor/investor')) {
            routeMessage.type = RequestType.GET;
            routeMessage.transferData = item?.routerData ? item.routerData : {};
        } else if (item.url.startsWith(NavigateRoutes.coBranding)) {
            item.routerData.apiParams = new CoBrandingApiQueryParams();
            routeMessage.transferData = item;
            routeMessage.type = item.requestType;
        } else if (item.url === NavigateRoutes.transactionHistory) {
            routeMessage.type = RequestType.GET;
            routeMessage.transferData = new QueryParams();
            routeMessage.transferData.apiParams.status = TransactionStatus.all;
            routeMessage.transferData.filterValue = TransactionStatus.all;
        } else if (item.url === NavigateRoutes.initiateTransaction) {
            routeMessage.type = RequestType.BLANK;
        } else {
            routeMessage.type = item.requestType;
            const nativeEl = this.sbAccordionGP;
            if (nativeEl.value === 'second') {
                nativeEl.value = undefined;
            } else {
                nativeEl.value = 'second';
            }
        }
        this.menuCtrl.close();
        if (!this.systemService.isTransactionRouteForPopup) {
            this.systemService.storageService.clearStorage();
        }
        this.systemService.routeByUrl(url, routeMessage);
        this.toggleMenu();
    }

    toggleMenu() {
        if (window.innerWidth < 992) {
            this.menuCtrl.toggle();
        }
    }

    onLogOut() {
        this.toggleMenu();
        // this.userLogsService.saveDetails(JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile)), 'logout', '');

        if (this.systemService.deviceInfo.platform !== 'web') {
            this.systemService.isTransactionRouteForPopup = false;
            // this.modalService.dismissAll();
            SmartechBaseCordova.logoutAndClearUserIdentity(false);
            this.storageService
                .clearStorage()
                .then(() => {
                    const routeMessage = new RouteMessage();
                    routeMessage.type = RequestType.BLANK;
                    routeMessage.transferData['hideBiomatricPopUp'] = false;
                    this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                })
                .catch((err) => {
                    this.systemService.showToaster('Something Went Wrong While Clear Storage', 'error');
                });
        } else {
            this.systemService.logOut();
        }
    }

    async onclickMinimizeSideBar(item: SideMenuItem) {
        if (!this.systemService.canNavigate) {
            this.systemService.showToaster('You are Offline!', 'error');
            return;
        }
        this.sbAccordionGP.value = `${item.id}`;
        if (item.subItems.length > 0) {
            item = item.subItems[0];
            this.systemService.minimizedSideBar = false;
        }
        const routeMessage = new RouteMessage();
        routeMessage.transferData = item;
        let url = item.url;
        if (item.url.startsWith(NavigateRoutes.accountStatement) || item.url.startsWith(NavigateRoutes.capitalGainStatement)) {
            url = NavigateRoutes.selectInvestor;
            if (item.url.startsWith(NavigateRoutes.accountStatement)) {
                url = url + '/account-statement';
            } else {
                url = url + '/capital-gain-statement';
            }
            routeMessage.type = RequestType.GET;
        } else if (item.url.startsWith('/distributor/investor')) {
            routeMessage.type = RequestType.GET;
            routeMessage.transferData = item?.routerData ? item.routerData : {};
        } else if (item.url.startsWith(NavigateRoutes.coBranding)) {
            item.routerData.apiParams = new CoBrandingApiQueryParams();
            routeMessage.transferData = item;
            routeMessage.type = item.requestType;
        } else {
            routeMessage.type = item.requestType;
        }
        this.menuCtrl.close();
        if (this.systemService.getLocalStorage('isInitiatTransaction') === 'false') {
            await this.systemService.storageService.clearStorage();
        }
        this.systemService.routeByUrl(url, routeMessage);
    }
}
